import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ThemeProviderProps } from 'next-themes';

/**
 * Thin wrapper around next-themes' ThemeProvider.
 *
 * Props are passed through verbatim so callers (main.tsx) can configure
 * `attribute`, `defaultTheme`, `enableSystem`, and `disableTransitionOnChange`
 * without this module needing to know about each one.
 *
 * next-themes persists the user's manual choice in `localStorage` under the
 * key "theme" automatically. On a fresh load with no stored preference it
 * falls back to `defaultTheme` (which we set to "system" so the OS setting
 * drives the initial render).
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps): React.JSX.Element {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
